import React from 'react';

const Testimonial = ({ text, author, title, organization, showStars = true }) => (
  <div className="bg-white shadow-lg rounded-2xl p-6 border border-gray-100 hover:shadow-xl transition-shadow">
    {showStars && (
      <div className="flex mb-3" aria-hidden="true">
        {[...Array(5)].map((_, index) => (
          <svg
            key={index}
            className="w-5 h-5 text-yellow fill-current"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
          </svg>
        ))}
      </div>
    )}
    <p className="text-gray-600 italic mb-4">"{text}"</p>
    <p className="font-bold">{author}</p>
    {(title || organization) && (
      <p className="text-sm text-gray-500">
        {title && `${title}${organization ? ', ' : ''}`}
        {organization}
      </p>
    )}
  </div>
);

export default Testimonial;